import { appendStripes, updateStripes } from './stripes';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export const headerVisuals = () => {
   const header = document.querySelector('.header--large');
   if (!header) return false;
   const initScroll = 0.03;
   const stripes = appendStripes(header, 150);
   updateStripes(stripes, initScroll);

   ScrollTrigger.create({
      trigger: '#header',
      start: 'top top',
      endTrigger: '#header',
      end: 'bottom top',
      // onToggle: (self) => console.log('toggled, isActive:', self.isActive),
      onUpdate: (self) => {
         updateStripes(stripes, self.progress + initScroll);
         // console.log('progress:', self.progress.toFixed(3), 'direction:', self.direction, 'velocity', self.getVelocity());
      },
   });
};
